import { createEmptyContext } from '../../../utils/create-empty-context';
/**
 * Seat Picker context will wrap all children components and be available as merged props
 */
export const SeatPickerContextInstance = createEmptyContext();
/**
 * Utility method to create `SeatPickerContext` object from `SeatPickerProps`.
 */
export function mapSeatPickerContext(props, config, onSeatClicked, seatIdToAppearanceRule) {
    return {
        data: props.data,
        config,
        displayText: props.displayText,
        isDisabled: props.isDisabled,
        onSeatClicked,
        seatIdToAppearanceRule
    };
}
// Separate the selectedSeats into another context as the selectedSeats will change often
// independent of the SeatPickerContext. This prevents unchanged SeatPickerRow and SeatPickerSeat
// components from re-rendering.
export const SeatPickerSelectedSeatsContextInstance = createEmptyContext();
//# sourceMappingURL=context.js.map